/**
 * WordPress dependencies
 */

export default {
	hookPrefix: 'testimonial',
	layouts: [ {
		name: 'layout-1',
		label: 'Layout 1',
		imageAlign: 'center',
		titleAlign: 'center',
		ratingAlign: 'center',
		thumbnailUrl: `${ window.gutenify_block_data.plugin_directory_url }/assets/images/testimonial-layouts/layout-1.png`,
	}, {
		name: 'layout-2',
		label: 'Layout 2',
		imageAlign: 'center',
		titleAlign: 'left',
		ratingAlign: 'left',
		thumbnailUrl: `${ window.gutenify_block_data.plugin_directory_url }/assets/images/testimonial-layouts/layout-2.png`,
	}, {
		name: 'layout-3',
		label: 'Layout 3',
		imageAlign: 'center',
		titleAlign: 'left',
		ratingAlign: 'left',
		thumbnailUrl: `${ window.gutenify_block_data.plugin_directory_url }/assets/images/testimonial-layouts/layout-3.png`,
	} ],
};
